if (!customElements.get('product-upsell')) {
  customElements.define(
    'product-upsell',
    class ProductUpsell extends HTMLElement {
      constructor() {
        super();
        const swiper = new Swiper(this.querySelector('.swiper'), {
          slidesPerView: this.dataset.perView ? this.dataset.perView : 3,
          spaceBetween: 20,
          watchOverflow: true,
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          scrollbar: {
            el: this.querySelector('.swiper-scrollbar'),
            hide: false,
            draggable: true,
          },
          // pagination: {
          //     el: this.querySelector(".swiper-pagination"),
          //     type: "progressbar",
          // },
          breakpoints: {
            750: {
              spaceBetween: 10,
            },
            990: {
              spaceBetween: 20,
            },
          },
        });
      }
    }
  );
}
